<template lang="pug">
  .component-force-rebook
    ModalReveal(sizing="small")
      button.button.danger(slot="trigger") Toggle hidden on map
      .header(slot="header")
        h2 Toggle hidden on map
        .row
          .column.small-8
            h2 V{{vehicle.id}} {{vehicle.brand}} {{vehicle.model}}
            h2 {{vehicle.plate}}
        .row
          .column.small-4
            label Hidden
            input(type="checkbox", v-model="body.hidden")
      ActionButton(:action="toggleHidden") Save
</template>

<script>
  import ModalReveal from '../../../foundation/ModalReveal'
  import SelectizeDriver from '../../lists/selectize/SelectizeDriver'
  import DatePicker from '../../../DatePicker'
  import ActionButton from '../../ActionButton'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../../maggieHelper'
  import {EventBus} from "src/eventBus";
  import Vehicle from 'components/backoffice/Vehicle'

  export default {
    name: 'ToggleHiddenOnMap',
    components: {Vehicle, ActionButton, DatePicker, SelectizeDriver, ModalReveal},
    data() {
      return {
        body: {
          hidden: this.vehicle.vehicle_slot_hidden,
        }
      }
    },
    methods: {
      setDriver(obj) {
        this.body.driver_id = obj.id
      },
      toggleHidden() {
        return KeplerBackofficeSdk.vehicles.select(this.vehicle.slot_id).toggleHidden({
          hidden: this.body.hidden
        }, () => {
          MaggieHelper.notification('Vehicle', 'Vehicle visibility  updated')
          EventBus.$emit('reload-list')
          EventBus.$emit('close-modal')
        })
      }
    },
    props: ['vehicle']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ToggleHiddenOnMap.vue?9217d4d4